import { render, staticRenderFns } from "./GuardarCuentas.vue?vue&type=template&id=c6edd72a&"
import script from "./GuardarCuentas.vue?vue&type=script&lang=js&"
export * from "./GuardarCuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports